import apiService from '../../../services/api'

class EventApi {
  // Запрос данных текущего ивента
  async getEventData() {
    return apiService.makeRequest('/api/event_ref/')
  }
}

const eventApi = new EventApi()

export default eventApi
